import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { createFromPrevious } from '../../../redux/newOffer';
import { imageFix } from '../../../helpers';

const Title = styled.div`
  width: 85px;
  font-size: 13px;
  margin: 0px 10px;
  text-align: center;
  line-height: 1.38;
  color: #333333;
  white-space: normal;
  height: 50px;
`;

const Image = styled.img`
  width: 85px;
  margin: 10px;
  box-shadow: 0 10px 20px 0 rgba(45, 48, 60, 0.15);
`;

const Placeholder = styled.div`
  width: 85px;
  height: 85px;
  margin: 4px 10px;
  display: inline-block;
  background-color: #cfcfcf;
`;

interface Props {
  createFromPrevious: Function;
  offer: Offer;
  business: any;
}

function MiniOffer(props: Props) {
  const { offer, createFromPrevious, business } = props;

  return (
    <div style={{ flex: '0 0 105px' }} onClick={() => createFromPrevious(business, offer)}>
      {offer.media && offer.media.length ? (
        <Image src={`${imageFix(offer.media[0].thumbnail)}`} alt="Previous offer" />
      ) : (
        <Placeholder />
      )}
      <br />
      <Title>{offer.subtitle}</Title>
    </div>
  );
}

export default connect(({ business }: any) => ({ business }), { createFromPrevious })(MiniOffer);
